import type { OrderDTO } from 'ecosystem'
import {
  fetchPropsFactory,
  storefrontApiCall,
  urlWithQueryParamsFactory
} from '../../utils/fetching'
import { INVOICE_ORDERS_ENDPOINT } from './constants'

export interface GetInvoiceOrderParams {
  orderNumber: string
  /** Hydrate `items` on the response. Required for any read that drives a
   * subsequent PUT/POST — those endpoints strip items, so the caller must round-
   * trip them via the GET. */
  includeItems?: boolean
  /** Hydrate the `customer` block on the response. */
  includeCustomer?: boolean
}

export async function getInvoiceOrderByOrderNumber(params: GetInvoiceOrderParams) {
  const url = urlWithQueryParamsFactory<GetInvoiceOrderParams>(`${INVOICE_ORDERS_ENDPOINT}/`, {
    queryParams: params
  })
  const props = fetchPropsFactory({
    props: {
      method: 'GET',
      credentials: 'include'
    }
  })

  return storefrontApiCall<OrderDTO>(url, props)
}
